/* so-reviews-pdp.js — the PDP customer section (snippets/so-reviews-pdp.liquid). T1, 2026-10-01.
 *
 * 1. Card row: fills to 8 cards — this product's reviews first (same rules as the Liquid pick), then, only if the
 *    product has fewer than 8 usable ones, judge.me SHOP reviews labelled "Store review".
 * 2. One-review dialog (a card opens it), with prev/next through the row and "See all N reviews".
 * 2b. Customer photos: the shared full-screen viewer (snippets/so-photo-viewer + assets/so-photo-viewer.js,
 *     window.soPhotoViewer — also used for the product's own photos); this file only hands it the photos and builds
 *     the review shown under a photo.
 * 3. All-reviews sheet: every judge.me page for this product is loaded in the background (30 per page, cap 300);
 *    insights and filters are computed client-side over that set. Store reviews live in their own tab.
 *
 * Data: cdn.judge.me/reviews/reviews_for_widget (JSON, public) and …/all_reviews_js_based?review_type=shop-reviews
 * (JSON wrapping HTML, parsed INERT). SECURITY: every value from judge.me reaches the page through textContent /
 * setAttribute only; image URLs are protocol-checked; no review HTML is ever inserted.
 * No schema is emitted; store reviews never touch the product's count or average.
 */
(function () {
  'use strict';
  if (window.__soReviewsPdp) return; window.__soReviewsPdp = true;
  var sec = document.getElementById('so-reviews');
  if (!sec || !sec.classList.contains('so-rvp')) return;

  // ---- config (one place) ----
  var CFG = {
    perPage: 30, maxReviews: 300, maxStore: 400, cards: 8, chunk: 20, parallel: 5, cacheHours: 12,
    // store reviews shown ON a product page: 5★, 20–160 chars, about delivery / service / product quality — never about
    // the website, never a stock complaint
    storeGood: /deliver|courier|arrived|fast|quick|service|support|helpful|friendly|quality|product|flavou?r|recommend/i,
    storeSkip: /website|web site|\bsite\b|navigat|\bui\b|\bux\b|ui\/ux|easy to use|user.friendly|checkout|out of stock|no stock|sold out|stock/i,
    bad: /not what|disappoint|crack|broke|wrong|faulty|late|never arrived|could be|should|wish|but /i,
    good: /taste|flavou?r|love|device|pouch|juice|smooth|quality|vape/i,
    // generic topics → keyword lists (filters in the all-reviews sheet)
    topics: [
      { key: 'taste', label: 'Flavour / taste', re: /flavou?r|taste|tasty|sweet|fruity|minty|menthol|delicious|yummy/i },
      { key: 'delivery', label: 'Delivery', re: /deliver|courier|arrived|shipping|shipped|fast|quick|on time|next day|same day/i },
      { key: 'service', label: 'Service', re: /service|support|helpful|friendly|communicat|whatsapp|response/i },
      { key: 'value', label: 'Value', re: /price|value|cheap|afford|worth|deal|bargain/i },
      { key: 'quality', label: 'Quality', re: /quality|smooth|lasts?|long.lasting|strong|hit|throat|premium/i },
      { key: 'device', label: 'Device', re: /device|battery|pod|coil|charge|leak|kit/i }
    ],
    // store reviews: store-relevant generic topics
    storeTopics: [
      { key: 'delivery', label: 'Delivery', re: /deliver|courier|arrived|shipping|shipped|fast|quick|on time|next day|same day/i },
      { key: 'service', label: 'Service', re: /service|support|helpful|friendly|communicat|whatsapp|response|assist/i },
      { key: 'site', label: 'Website / ordering', re: /website|site|order(ing|ed)?\b|easy to|checkout|navigate|online/i },
      { key: 'value', label: 'Value', re: /price|value|cheap|afford|worth|deal|bargain|special/i },
      { key: 'stock', label: 'Stock / availability', re: /stock|available|availability|sold out|range|variety|selection/i },
      { key: 'payment', label: 'Payment', re: /pay(ment|flex|fast)?\b|card|eft|refund/i }
    ]
  };
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var D = sec.dataset, TOTAL = parseInt(D.total, 10) || 0, CUR = (D.flavour || '').trim();
  var $ = function (s, r) { return (r || sec).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || sec).querySelectorAll(s)); };
  var el = function (tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  var safeUrl = function (u) { var s = String(u == null ? '' : u).trim(); return /^(https:|\/\/)/i.test(s) ? s : ''; };
  var fmtDate = function (iso) { var d = new Date(iso); return isNaN(d.getTime()) ? '' : String(d.getDate()).padStart(2, '0') + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear(); };
  var plain = function (html) { try { return (new DOMParser().parseFromString(String(html || ''), 'text/html').body.textContent || '').replace(/\n{3,}/g, '\n\n').trim(); } catch (e) { return ''; } };
  var nrm = function (x) { return String(x || '').toLowerCase().replace(/[.,!?'"…]/g, '').replace(/\s+/g, ' ').trim(); };

  // one review, normalised (metafield rows have `body`; the API has only `body_html`)
  function norm(r, i) {
    var body = r.body != null && String(r.body).trim() ? String(r.body).trim() : plain(r.body_html);
    body = body.replace(/[ \t]+\n/g, '\n').replace(/\n\s*\n+/g, '\n').trim();
    var t = String(r.title || '').trim(), tn = nrm(t), bn = nrm(body);
    var showTitle = !!tn && tn !== bn && bn.indexOf(tn) !== 0 && !(bn && tn.indexOf(bn) === 0);
    var pics = (Array.isArray(r.pictures_urls) ? r.pictures_urls : []).map(function (p) {
      return { small: safeUrl(p.small || p.compact || p.original), mid: safeUrl(p.compact || p.small || p.original), big: safeUrl(p.huge || p.original || p.compact) };
    }).filter(function (p) { return p.small; });
    return { id: String(r.uuid || ('i' + i)), name: String(r.reviewer_name || 'Verified buyer').trim(), rating: Number(r.rating) || 0, date: r.created_at || '',
      title: showTitle ? t : '', body: body, variant: String(r.product_variant_title || '').trim(), pics: pics, verified: !!r.verified_buyer, store: !!r.store,
      reply: r.reply_content ? String(r.reply_content) : '' };
  }
  function score(r) {   // the Liquid pick's rules
    if (r.rating < 4 || r.body.length < 10 || CFG.bad.test(r.body)) return -1;
    var s = 20;
    if (r.variant && CUR && r.variant.toLowerCase() === CUR.toLowerCase()) s += 40;
    if (CFG.good.test(r.body)) s += 20; else if (/deliver/i.test(r.body)) s -= 10;
    return s;
  }
  function stars(n, cls) { var s = el('span', cls || 'so-rvp-stars', '★★★★★'); s.style.setProperty('--rating', String(n)); s.setAttribute('role', 'img'); s.setAttribute('aria-label', n + ' out of 5 stars'); return s; }

  // ---------------- data ----------------
  var all = [], loaded = false, loading = null;
  try { var ssr = JSON.parse(($('[data-so-rvp-data]') || {}).textContent || '[]'); if (Array.isArray(ssr)) all = ssr.map(norm); } catch (e) { all = []; }
  function pageUrl(page) {
    var q = new URLSearchParams({ product_id: D.productId, page: String(page), per_page: String(CFG.perPage), sort_by: 'created_at', sort_dir: 'desc',
      translation_locale: 'en', skip_other_languages: 'true', widget_theme: 'standard', ts: D.ts || '', shop_domain: D.shopDomain, platform: 'shopify' });
    return 'https://cdn.judge.me/reviews/reviews_for_widget?' + q.toString();
  }
  function getPage(page) {
    return fetch(pageUrl(page), { credentials: 'omit' }).then(function (r) { if (!r.ok) throw r.status; return r.json(); })
      .then(function (d) { return { reviews: (Array.isArray(d.reviews) ? d.reviews : []).map(norm), pages: (d.pagination && d.pagination.total_pages) || 1 }; });
  }
  // sessionStorage cache (12h): the parsed reviews, per product, and ONE shared entry for the store feed — so the
  // pop-up is instant on a second open and the Store tab is instant on the next product page.
  function cacheGet(key) { try { var c = JSON.parse(sessionStorage.getItem(key) || 'null'); return c && Date.now() - c.t < CFG.cacheHours * 36e5 ? c : null; } catch (e) { return null; } }
  function cacheSet(key, val) { try { val.t = Date.now(); sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }
  // run fn(n) for every n with at most CFG.parallel in flight
  function pool(nums, fn) {
    return new Promise(function (res) {
      var i = 0, live = 0, failed = false;
      (function next() {
        if (i >= nums.length && !live) { res(failed); return; }
        while (live < CFG.parallel && i < nums.length) { live++; fn(nums[i++]).catch(function () { failed = true; }).then(function () { live--; next(); }); }
      })();
    });
  }
  var PKEY = 'soRv:p:' + D.productId, SKEY = 'soRv:store';
  var firstPage = null;                       // 30 newest: enough to fill the card row
  function loadFirst() {
    if (firstPage) return firstPage;
    var c = cacheGet(PKEY);
    if (c && Array.isArray(c.reviews) && c.reviews.length) { all = c.reviews; loaded = true; firstPage = Promise.resolve({ reviews: all, pages: 1, cached: true }); return firstPage; }
    firstPage = (TOTAL > 0 ? getPage(1) : Promise.resolve({ reviews: [], pages: 1 })).then(function (p) { if (p.reviews.length) all = p.reviews; return p; });
    return firstPage;
  }
  function loadAll() {                        // every remaining page IN PARALLEL, capped; the views repaint as pages arrive
    if (loading) return loading;
    loading = loadFirst().then(function (p) {
      if (p.cached) return false;
      var pages = Math.min(p.pages, Math.ceil(CFG.maxReviews / CFG.perPage)), nums = [], got = [p.reviews];
      for (var i = 2; i <= pages; i++) nums.push(i);
      return pool(nums, function (n) { return getPage(n).then(function (x) { got[n - 1] = x.reviews; all = [].concat.apply([], got.filter(Boolean)); repaint(); }); });
    }).then(function (failed) { loaded = true; state.partial = !!failed; if (!failed && all.length) cacheSet(PKEY, { reviews: all }); }, function () { loaded = true; state.partial = true; });
    return loading;
  }
  // shop (store) reviews
  var shopP1 = null, shopCount = 0;
  function setShopCount(n) {
    if (!n) return; shopCount = n;
    var c = $('[data-so-store-count]'); if (c) c.textContent = ' (' + n.toLocaleString('en-ZA') + ')';
    $$('[data-so-store-n]').forEach(function (x) { x.textContent = n.toLocaleString('en-ZA'); });
  }
  var storeCache = cacheGet(SKEY); if (storeCache) setShopCount(storeCache.count);
  function shopPage(page) {
    if (page === 1 && !shopP1 && storeCache && Array.isArray(storeCache.reviews)) shopP1 = Promise.resolve(storeCache.reviews);   // top-up + tab: no fetch
    var url = 'https://cdn.judge.me/reviews/all_reviews_js_based?shop_domain=' + encodeURIComponent(D.shopDomain) + '&review_type=shop-reviews&page=' + page;
    var go = fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw r.status; return r.json(); }).then(function (j) {
      setShopCount(Number(j.number_of_shop_reviews));
      var doc = new DOMParser().parseFromString(String(j.html || ''), 'text/html');
      return [].slice.call(doc.querySelectorAll('.jdgm-rev')).map(function (n, i) {
        var ts = n.querySelector('.jdgm-rev__timestamp'), sc = n.querySelector('[data-score]');
        return norm({ uuid: n.getAttribute('data-review-id') || ('s' + page + '-' + i), reviewer_name: (n.querySelector('.jdgm-rev__author') || {}).textContent, rating: sc ? sc.getAttribute('data-score') : 0,
          created_at: ts ? (ts.getAttribute('data-content') || ts.textContent) : '', title: (n.querySelector('.jdgm-rev__title') || {}).textContent,
          body: ((n.querySelector('.jdgm-rev__body') || {}).textContent || '').trim(), verified_buyer: n.getAttribute('data-verified-buyer') === 'true', store: true }, i);
      });
    });
    if (page === 1) { if (!shopP1) shopP1 = go.catch(function (e) { shopP1 = null; throw e; }); return shopP1; }
    return go;
  }

  // ---------------- 1. the card row ----------------
  var picks = $('[data-so-picks]'), nav = $('[data-so-rv-nav]'), row = [];
  function cardNode(r) {    // the so-review-card markup (static skeleton; values via textContent)
    var li = el('li', 'so-rvp__pick' + (r.store ? ' is-store' : '')); li.tabIndex = 0; li.setAttribute('role', 'button'); li.setAttribute('aria-haspopup', 'dialog');
    li.setAttribute('aria-label', 'Read the review from ' + r.name); li.setAttribute('data-rv-id', r.id);
    var c = el('div', 'sov__c'), top = el('div', 'sov__top'), n = Math.max(0, Math.min(5, Math.round(r.rating)));
    var cs = el('div', 'sov__cs', '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n)); cs.setAttribute('role', 'img'); cs.setAttribute('aria-label', n + ' out of 5 stars');
    top.appendChild(cs); if (r.store) top.appendChild(el('span', 'so-rvp__chip', 'Store review')); else if (r.variant) top.appendChild(el('span', 'so-rvp__chip', r.variant));
    var by = el('div', 'sov__by'); by.appendChild(el('b', '', r.name));
    if (r.verified) by.appendChild(el('span', 'sov__vb', '✓ Verified'));
    if (r.pics.length) { var a = el('span', 'sov__aside'), im = el('img', 'so-rvp__thumb'); im.src = r.pics[0].small; im.alt = ''; im.width = 40; im.height = 40; im.loading = 'lazy'; a.appendChild(im); by.appendChild(a); }
    c.appendChild(top); c.appendChild(el('p', 'sov__q', '“' + r.body + '”')); c.appendChild(by); li.appendChild(c);
    return li;
  }
  function pickRow(list) {
    return list.map(function (r, i) { return { r: r, s: score(r), i: i }; }).filter(function (x) { return x.s > 0; })
      .sort(function (a, b) { return b.s - a.s || a.i - b.i; }).slice(0, CFG.cards).map(function (x) { return x.r; });
  }
  function drawRow(list) {
    if (!picks) return;
    row = list;
    picks.textContent = ''; picks.scrollLeft = 0;
    list.forEach(function (r) { picks.appendChild(cardNode(r)); });
    picks.classList.toggle('is-two', list.length > 4);
    requestAnimationFrame(function () { if (nav) nav.hidden = !(picks.scrollWidth > picks.clientWidth + 4); });
  }
  function fillRow() {
    loadFirst().then(function (p) {
      var mine = pickRow(p.reviews.length ? p.reviews : all);
      if (!p.cached && p.pages > 1) (window.requestIdleCallback || function (f) { return setTimeout(f, 2500); })(function () { loadAll(); }, { timeout: 6000 });
      if (mine.length >= CFG.cards || !D.shopDomain) { drawRow(mine); return; }
      // store top-up: page 1 of the shop feed, then pages 2–3 only if it still has too few usable quotes
      var need = CFG.cards - mine.length, found = [];
      var take = function (rs) {
        rs.map(function (r, i) { return { r: r, i: i, ok: r.rating >= 5 && r.body.length >= 20 && r.body.length <= 160 && !CFG.bad.test(r.body) && !CFG.storeSkip.test(r.title + ' ' + r.body),
          s: CFG.storeGood.test(r.body) ? 1 : 0 }; }).filter(function (x) { return x.ok; }).sort(function (a, b) { return b.s - a.s || a.i - b.i; }).forEach(function (x) { found.push(x.r); });
      };
      var step = function (n) {
        return shopPage(n).then(function (rs) {
          if (n === 1 && !storeCache) { storeCache = { count: shopCount, reviews: rs, full: false }; cacheSet(SKEY, storeCache); }
          take(rs);
          if (found.length < need && n < 3 && rs.length) return step(n + 1);
        });
      };
      return step(1).then(function () { drawRow(mine.concat(found.slice(0, need)));
      }, function () { drawRow(mine); });
    }).catch(function () {});
  }
  // the server-rendered cards work before (and without) the fill: map them to the SSR reviews by index
  row = $$('.so-rvp__pick', picks).map(function (li) { var r = all[parseInt(li.getAttribute('data-rv-i'), 10)]; if (r) li.setAttribute('data-rv-id', r.id); return r; }).filter(Boolean);
  if (picks) picks.classList.toggle('is-two', row.length > 4);
  if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); fillRow(); } }, { rootMargin: '600px 0px' }); io.observe(sec); } else fillRow();
  if (nav) {
    nav.hidden = !(picks && picks.scrollWidth > picks.clientWidth + 4);
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('[data-so-rv-step]'); if (!b || !picks) return;
      var c = picks.querySelector('.so-rvp__pick'); var w = c ? c.getBoundingClientRect().width + 16 : picks.clientWidth;
      picks.scrollBy({ left: Number(b.getAttribute('data-so-rv-step')) * w, behavior: 'smooth' });
    });
  }

  // ---------------- pop-up shell (the site's .so-dsheet; soSheetSwipe when present) ----------------
  var openEl = null, lastFocus = null, saved = null;
  var PV = function () { return window.soPhotoViewer || null; }, pvOn = function () { var v = PV(); return !!(v && v.isOpen()); };
  function trap(e, box) {
    var f = $$('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])', box).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var a = document.activeElement, first = f[0], last = f[f.length - 1];
    if (e.shiftKey ? (a === first || f.indexOf(a) < 0) : (a === last || f.indexOf(a) < 0)) { (e.shiftKey ? last : first).focus(); e.preventDefault(); }
  }
  function onKey(e) {
    if (pvOn()) return;                                         // the photo viewer sits on top and owns the keys
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab' && openEl) trap(e, openEl);
  }
  function open(sheet, from) {
    if (openEl && openEl !== sheet) { openEl.classList.remove('is-open'); openEl.hidden = true; }
    else if (!openEl) {
      lastFocus = from || document.activeElement;
      saved = { h: document.documentElement.style.overflow, b: document.body.style.overflow };
      document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey, true);
    }
    openEl = sheet; clearTimeout(sheet._t); sheet.classList.remove('is-closing'); sheet.hidden = false;
    var panel = $('.so-dsheet__panel', sheet);
    if (window.soSheetSwipe && panel) window.soSheetSwipe.attach(panel, { handle: '.so-dsheet__grab, .so-dsheet__head', scroller: '.so-dsheet__body', backdrop: $('.so-dsheet__backdrop', sheet), onClose: close });
    void sheet.offsetWidth; sheet.classList.add('is-open');
    var t = $('.so-dsheet__title', sheet); if (t) t.focus({ preventScroll: true });
  }
  function close() {
    if (!openEl) return;
    var s = openEl; openEl = null;
    s.classList.remove('is-open'); s.classList.add('is-closing');
    s._t = setTimeout(function () { s.hidden = true; s.classList.remove('is-closing'); }, 260);
    if (saved) { document.documentElement.style.overflow = saved.h; document.body.style.overflow = saved.b; saved = null; }
    document.removeEventListener('keydown', onKey, true);
    if (lastFocus && lastFocus.isConnected) lastFocus.focus({ preventScroll: true });
  }
  $$('[data-so-rvp-close]').forEach(function (b) { b.addEventListener('click', close); });

  // ---------------- customer PHOTOS: the shared viewer (window.soPhotoViewer); the data and the caption are ours ----------------
  // Photos = every picture of every loaded review of THIS product (newest review first); the set grows as pages arrive.
  var pvMine = false;                                           // the viewer is showing OUR photos (it also shows the product's own)
  var pkey = function (u) { return String(u || '').split('?')[0].split('/').pop(); };
  function pvPhotos() { var out = []; all.forEach(function (r) { r.pics.forEach(function (p, i) { out.push({ small: p.small, mid: p.mid, big: p.big, key: pkey(p.small), alt: 'Customer photo from ' + r.name, label: 'Photo from ' + r.name, r: r }); }); }); return out; }
  function pvReview(r) {
    var w = el('div', 'so-rvp-row'), head = el('div', 'so-rvp-row__head'); head.appendChild(stars(r.rating)); head.appendChild(el('span', 'so-rvp-row__date', fmtDate(r.date))); w.appendChild(head);
    var body = el('div', 'so-rvp-row__body', r.body ? '“' + r.body + '”' : r.title); w.appendChild(body);
    if (r.body.length > 150) {
      body.classList.add('is-clamped');
      var m = el('button', 'so-rvp__link', 'Read more'); m.type = 'button'; m.setAttribute('aria-expanded', 'false');
      m.addEventListener('click', function () { var o = body.classList.toggle('is-clamped') === false; m.textContent = o ? 'Read less' : 'Read more'; m.setAttribute('aria-expanded', String(o)); });
      w.appendChild(m);
    }
    var by = el('div', 'so-rvp-row__by'); by.appendChild(el('b', '', r.name));
    if (r.verified) by.appendChild(el('span', 'so-rvp-verified', '✓ Verified'));
    if (r.variant) by.appendChild(el('span', 'so-rvp__chip', r.variant));
    w.appendChild(by);
    return w;
  }
  function pvState() { return { emptyText: loaded ? 'No customer photos yet.' : 'Loading photos…', countNote: loaded ? '' : ' · updating…' }; }
  function pvBuild() {                                          // (re)build from the loaded reviews; the viewer keeps the current photo
    var list = pvPhotos(), v = PV();
    $$('[data-so-rv-photo-n]').forEach(function (x) { if (loaded && list.length) x.textContent = String(list.length); });
    if (v && pvMine && v.isOpen()) v.update(list, pvState());
  }
  // url: a photo's URL (opens the large view there) — or nothing (opens the grid)
  function pvOpen(from, url) {
    var v = PV(); if (!v) return;
    var o = pvState(), n = parseInt(sec.getAttribute('data-total'), 10) || 0;
    o.photos = pvPhotos(); o.title = 'Customer photos';
    o.caption = function (x) { return x.r ? pvReview(x.r) : null; };
    if (url) o.key = pkey(url);
    if (n > 0) o.footer = { label: 'See all ' + n + ' reviews ›', onClick: function (f) { var under = openEl === sheet; v.close(false); if (!under) openAll(openEl ? lastFocus : f); } };
    o.onClose = function () { pvMine = false; };
    pvMine = v.open(from || document.activeElement, o) !== false;
    if (!loaded) loadAll().then(pvBuild);
  }

  // a full review (the one-review dialog and the list rows share it)
  function reviewNode(r, clamp) {
    var li = el('li', 'so-rvp-row' + (r.store ? ' is-store' : '')); li.setAttribute('data-rv-id', r.id);
    var head = el('div', 'so-rvp-row__head'); head.appendChild(stars(r.rating)); head.appendChild(el('span', 'so-rvp-row__date', fmtDate(r.date)));
    li.appendChild(head);
    if (r.title) li.appendChild(el('h3', 'so-rvp-row__title', r.title));
    var body = el('div', 'so-rvp-row__body', r.body); li.appendChild(body);
    if (clamp && r.body.length > 320) {
      body.classList.add('is-clamped');
      var m = el('button', 'so-rvp__link', 'Read more'); m.type = 'button'; m.setAttribute('aria-expanded', 'false');
      m.addEventListener('click', function () { var o = body.classList.toggle('is-clamped') === false; m.textContent = o ? 'Read less' : 'Read more'; m.setAttribute('aria-expanded', String(o)); });
      li.appendChild(m);
    }
    if (r.pics.length) {
      var ph = el('div', 'so-rvp-row__photos');
      r.pics.slice(0, 4).forEach(function (p) { var b = el('button'); b.type = 'button'; b.setAttribute('aria-label', 'View photo from ' + r.name); var im = el('img'); im.src = p.small; im.alt = ''; im.loading = 'lazy';
        b.appendChild(im); b.addEventListener('click', function (e) { e.stopPropagation(); pvOpen(b, p.small); }); ph.appendChild(b); });
      li.appendChild(ph);
    }
    var by = el('div', 'so-rvp-row__by'); by.appendChild(el('span', 'so-rvp-row__av', (r.name.charAt(0) || '·').toUpperCase())); by.appendChild(el('b', '', r.name));
    if (r.verified) by.appendChild(el('span', 'so-rvp-verified', '✓ Verified'));
    if (r.store) by.appendChild(el('span', 'so-rvp-row__label', 'Store review'));
    if (r.variant) by.appendChild(el('span', 'so-rvp__chip', r.variant));
    li.appendChild(by);
    if (r.reply) { var rp = el('div', 'so-rvp-row__reply'); rp.appendChild(el('b', '', 'Smoke Organic Store replied')); rp.appendChild(el('span', '', ' ' + r.reply)); li.appendChild(rp); }
    return li;
  }

  // ---------------- 2. ONE review ----------------
  var one = $('[data-so-rvp-one]'), oneBody = $('[data-so-rvp-one-body]'), oneIdx = -1;
  function showOne(i, from) {
    if (!one || !row.length) return;
    oneIdx = (i + row.length) % row.length;
    oneBody.textContent = ''; var n = reviewNode(row[oneIdx], false); var ul = el('ul', 'so-rvp-all__list so-rvp-one__list'); ul.appendChild(n); oneBody.appendChild(ul);
    var step = $('.so-rvp-one__step', one); if (step) step.hidden = row.length < 2;
    open(one, from);
  }
  if (one) one.addEventListener('click', function (e) { var b = e.target.closest('[data-so-rvp-one-step]'); if (b) showOne(oneIdx + Number(b.getAttribute('data-so-rvp-one-step'))); });
  if (picks) {
    picks.addEventListener('click', function (e) {
      var c = e.target.closest('.so-rvp__pick'); if (!c) return;
      var th = e.target.closest('.so-rvp__thumb'); if (th) { pvOpen(c, th.currentSrc || th.src); return; }   // a card's photo thumb → the photo viewer
      var id = c.getAttribute('data-rv-id'), i = row.map(function (r) { return r.id; }).indexOf(id);
      if (i >= 0) showOne(i, c);
    });
    picks.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('so-rvp__pick')) { e.preventDefault(); e.target.click(); } });
  }

  // ---------------- 3. ALL reviews: two tabs, ONE view component (sidebar insights/filters + list) ----------------
  var sheet = $('[data-so-rvp-sheet]'), panelP = $('[data-so-rvp-panel="p"]'), panelS = $('[data-so-rvp-panel="s"]');
  var hist = []; try { hist = JSON.parse(($('[data-so-rvp-hist]') || {}).textContent || '[]'); } catch (e) { hist = []; }
  function chip(label, count, on, fn) {
    var b = el('button', 'so-rvp-f' + (on ? ' is-on' : '')); b.type = 'button'; b.setAttribute('aria-pressed', String(!!on));
    b.appendChild(el('span', '', label)); if (count != null) b.appendChild(el('i', '', String(count)));
    b.addEventListener('click', fn); return b;
  }
  function group(title, cls) { var g = el('div', 'so-rvp-g' + (cls ? ' ' + cls : '')); if (title) g.appendChild(el('p', 'so-rvp-g__t', title)); return g; }
  // o: { panel, get() → reviews, loaded() → bool, partial() → bool, total() → n, score() → {avg, five, hist:[{rating, frequency, percentage}]},
  //      topics, flavours: bool, photos: bool, noun, extra: text|'' }
  function View(o) {
    var P = o.panel, side = $('[data-so-rvp-filters]', P), listEl = $('[data-so-rvp-list]', P), countEl = $('[data-so-rvp-count]', P), emptyEl = $('[data-so-rvp-empty]', P);
    var moreEl = $('[data-so-rvp-more]', P), sortEl = $('[data-so-rvp-sort]', P), qEl = $('[data-so-rvp-q]', P);
    var st = { rating: 0, photos: false, flavour: '', topic: '', q: '', sort: 'recent', shown: CFG.chunk };
    function matches(r) {
      if (st.rating && Math.round(r.rating) !== st.rating) return false;
      if (st.photos && !r.pics.length) return false;
      if (st.flavour && r.variant !== st.flavour) return false;
      if (st.topic) { var t = o.topics.filter(function (x) { return x.key === st.topic; })[0]; if (t && !t.re.test(r.title + ' ' + r.body)) return false; }
      if (st.q) { var q = st.q.toLowerCase(); if ((r.title + ' ' + r.body + ' ' + r.name + ' ' + r.variant).toLowerCase().indexOf(q) < 0) return false; }
      return true;
    }
    function sorted(list) {
      var l = list.slice(), t = function (r) { return new Date(r.date).getTime() || 0; };
      if (st.sort === 'high') l.sort(function (a, b) { return b.rating - a.rating || t(b) - t(a); });
      else if (st.sort === 'low') l.sort(function (a, b) { return a.rating - b.rating || t(b) - t(a); });
      else if (st.sort === 'photos') l.sort(function (a, b) { return (b.pics.length ? 1 : 0) - (a.pics.length ? 1 : 0) || t(b) - t(a); });
      else l.sort(function (a, b) { return t(b) - t(a); });
      return l;
    }
    function renderSide() {
      if (!side) return;
      var all = o.get(), sc0 = o.score(), total = o.total();
      var keep = document.activeElement && side.contains(document.activeElement) ? document.activeElement.getAttribute('data-k') : null;
      side.textContent = '';
      var sc = group('', 'so-rvp-g--score'), big = el('p', 'so-rvp-all__score');
      if (sc0.avg) { big.appendChild(el('b', '', sc0.avg)); big.appendChild(stars(Number(sc0.avg))); }
      big.appendChild(el('span', '', total + ' ' + o.noun + (total === 1 ? '' : 's')));
      sc.appendChild(big); if (Number(sc0.five) > 0) sc.appendChild(el('p', 'so-rvp-all__five', sc0.five + '% ' + (o.fiveText || 'of buyers rated it 5★')));
      if (o.extra) sc.appendChild(el('p', 'so-rvp-all__five', o.extra));
      side.appendChild(sc);
      if (sc0.hist.length) {
        var g1 = group('Rating', 'so-rvp-g--rating');
        sc0.hist.forEach(function (h) {
          var n = Number(h.frequency) || 0, on = st.rating === Number(h.rating);
          var b = el('button', 'so-rvp-hrow' + (on ? ' is-on' : '')); b.type = 'button'; b.disabled = !n; b.setAttribute('aria-pressed', String(on)); b.setAttribute('data-k', 'r' + h.rating);
          b.setAttribute('aria-label', 'Show only ' + h.rating + ' star reviews (' + n + ')');
          var lab = el('span', 'so-rvp-hrow__s', h.rating + ' '); lab.appendChild(el('i', '', '★')); b.appendChild(lab);
          var tr = el('span', 'so-rvp-hrow__t'), fill = el('span'); fill.style.width = (Number(h.percentage) || 0) + '%'; tr.appendChild(fill); b.appendChild(tr);
          b.appendChild(el('span', 'so-rvp-hrow__n', on ? '×' : String(n)));
          b.addEventListener('click', function () { st.rating = on ? 0 : Number(h.rating); apply(); });
          g1.appendChild(b);
        });
        side.appendChild(g1);
      }
      var refocus = function () { if (keep) { var k = side.querySelector('[data-k="' + keep + '"]'); if (k) k.focus(); } };
      // progressive: the groups below show what is loaded so far and firm up as pages arrive
      if (o.photos) { var nPh = all.filter(function (r) { return r.pics.length; }).length;
        if (nPh) { var g2 = group('', 'so-rvp-g--photos'), pb = chip('With photos', nPh, st.photos, function () { st.photos = !st.photos; apply(); }); pb.setAttribute('data-k', 'ph'); g2.appendChild(pb); side.appendChild(g2); } }
      if (o.flavours) {
        var fl = {}; all.forEach(function (r) { if (!r.variant) return; (fl[r.variant] = fl[r.variant] || { n: 0, sum: 0 }); fl[r.variant].n++; fl[r.variant].sum += r.rating; });
        var names = Object.keys(fl).sort(function (a, b) { return (b === CUR) - (a === CUR) || fl[b].n - fl[a].n || a.localeCompare(b); });
        if (names.length > 1) {
          var g3 = group('Flavour', 'so-rvp-g--flavour'), sel = el('select', 'so-rvp-all__sel'); sel.setAttribute('aria-label', 'Filter by flavour'); sel.setAttribute('data-k', 'fl');
          var o0 = el('option', '', 'All flavours'); o0.value = ''; sel.appendChild(o0);
          names.forEach(function (n) { var op = el('option', '', n + ' (' + fl[n].n + ')' + (n === CUR ? ' · selected flavour' : '')); op.value = n; if (n === st.flavour) op.selected = true; sel.appendChild(op); });
          sel.addEventListener('change', function () { st.flavour = sel.value; apply(); });
          g3.appendChild(sel);
          if (fl[CUR] && st.flavour !== CUR) { var cb = chip('Only ' + CUR, fl[CUR].n, false, function () { st.flavour = CUR; apply(); }); cb.setAttribute('data-k', 'cur'); g3.appendChild(cb); }
          side.appendChild(g3);
          var top = names.filter(function (n) { return fl[n].n >= 3; }).map(function (n) { return { n: n, avg: fl[n].sum / fl[n].n, c: fl[n].n }; })
            .sort(function (a, b) { return b.avg - a.avg || b.c - a.c; }).slice(0, 3);
          if (top.length) { var g4 = group('Top-rated flavours', 'so-rvp-g--top'), ol = el('ol', 'so-rvp-top');
            top.forEach(function (t) { var li = el('li'); var b = el('button', 'so-rvp__link', t.n); b.type = 'button'; b.addEventListener('click', function () { st.flavour = t.n; apply(); });
              li.appendChild(b); li.appendChild(el('span', '', ' ' + t.avg.toFixed(1) + '★ · ' + t.c)); ol.appendChild(li); });
            g4.appendChild(ol); side.appendChild(g4); }
        }
      }
      var g5 = group('Customers mention', 'so-rvp-g--topics'), any = false;
      o.topics.forEach(function (t) { var n = all.filter(function (r) { return t.re.test(r.title + ' ' + r.body); }).length; if (!n) return; any = true;
        var b = chip(t.label, n, st.topic === t.key, function () { st.topic = st.topic === t.key ? '' : t.key; apply(); }); b.setAttribute('data-k', 't' + t.key); g5.appendChild(b); });
      if (any) side.appendChild(g5);
      if (!o.loaded()) side.appendChild(el('p', 'so-rvp-all__loading', 'updating…'));
      if (o.partial()) side.appendChild(el('p', 'so-rvp-all__loading', 'Some reviews could not be loaded; counts cover ' + all.length + '.'));
      // everything after the score sits in ONE box: phones scroll it sideways as the filter row, under the score line
      var box = el('div', 'so-rvp-all__chips'); while (side.children.length > 1) box.appendChild(side.children[1]); side.appendChild(box);
      refocus();
    }
    function renderList() {
      if (!listEl) return;
      var res = sorted(o.get().filter(matches)).filter(function (r) { return r.body || r.title; }), bits = [];
      if (st.rating) bits.push(st.rating + '★'); if (st.photos) bits.push('with photos'); if (st.flavour) bits.push(st.flavour);
      if (st.topic) bits.push((o.topics.filter(function (t) { return t.key === st.topic; })[0] || {}).label); if (st.q) bits.push('“' + st.q + '”');
      var filtered = bits.length > 0, ld = o.loaded(), pool = filtered || ld ? res.length : Math.max(o.total(), res.length), shown = Math.min(st.shown, res.length);
      listEl.textContent = ''; res.slice(0, shown).forEach(function (r) { listEl.appendChild(reviewNode(r, true)); });
      if (countEl) {
        countEl.textContent = 'Showing ' + shown + ' of ' + (filtered && !ld ? res.length + '+' : pool) + (filtered ? ' · ' + bits.join(' · ') : '') + (!ld ? ' · updating…' : '');
        if (filtered) { var c = el('button', 'so-rvp__link', 'Clear ×'); c.type = 'button'; c.addEventListener('click', clear); countEl.appendChild(document.createTextNode(' ')); countEl.appendChild(c); }
      }
      if (emptyEl) emptyEl.hidden = res.length > 0 || !ld;
      if (moreEl) moreEl.hidden = shown >= res.length;
    }
    function apply() { st.shown = CFG.chunk; renderSide(); renderList(); var b = $('.so-dsheet__body', sheet); if (b) b.scrollTop = 0; }
    function clear() { st.rating = 0; st.photos = false; st.flavour = ''; st.topic = ''; st.q = ''; if (qEl) qEl.value = ''; apply(); }
    if (sortEl) sortEl.addEventListener('change', function () { st.sort = sortEl.value; st.shown = CFG.chunk; renderList(); });
    if (qEl) { var qt; qEl.addEventListener('input', function () { clearTimeout(qt); qt = setTimeout(function () { st.q = qEl.value.trim(); st.shown = CFG.chunk; renderList(); }, 180); }); }
    if (moreEl) moreEl.addEventListener('click', function () { st.shown += CFG.chunk; renderList(); });
    if (emptyEl) emptyEl.addEventListener('click', function (e) { if (e.target.closest('[data-so-rvp-clear]')) clear(); });
    return { state: st, render: function () { renderSide(); renderList(); }, renderSide: renderSide, renderList: renderList };
  }

  var partial = false;
  var viewP = panelP ? View({ panel: panelP, get: function () { return all; }, loaded: function () { return loaded; }, partial: function () { return partial; }, total: function () { return TOTAL; },
    score: function () { return { avg: D.avg, five: D.five, hist: hist }; }, topics: CFG.topics, flavours: true, photos: true, noun: 'review' }) : null;
  var rpT = 0;
  function repaint() { if (rpT) return; rpT = setTimeout(function () { rpT = 0; if (viewP && sheet && !sheet.hidden) viewP.render(); if (pvMine) pvBuild(); }, 120); }   // as pages arrive
  function renderSide() { if (viewP) viewP.renderSide(); }

  // store tab: every shop-review page in the background (25 per page, cap), same view
  var storeAll = [], storeLoaded = false, storeLoading = null, storePartial = false;
  function storeScore() {
    var rated = storeAll.filter(function (r) { return r.rating > 0; }), n = rated.length; if (!n) return { avg: '', five: 0, hist: [] };
    var sum = 0, by = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 }; rated.forEach(function (r) { sum += r.rating; by[Math.round(r.rating)] = (by[Math.round(r.rating)] || 0) + 1; });
    return { avg: (sum / n).toFixed(2), five: Math.round(by[5] / n * 100), hist: [5, 4, 3, 2, 1].map(function (k) { return { rating: k, frequency: by[k], percentage: Math.round(by[k] / n * 100) }; }) };
  }
  var viewS = panelS ? View({ panel: panelS, get: function () { return storeAll; }, loaded: function () { return storeLoaded; }, partial: function () { return storePartial; },
    total: function () { return shopCount || storeAll.length; }, score: function () { return storeScore(); },
    topics: CFG.storeTopics, flavours: false, photos: false, noun: 'store review', fiveText: 'rated the store 5★', extra: D.customers ? D.customers + ' customers served' : '' }) : null;
  function loadStoreAll() {
    if (storeLoading) return storeLoading;
    var done = function () {
      if (panelS) panelS.classList.remove('is-loading');
      if (viewS) viewS.render();
      var sc = storePartial ? null : storeScore();            // ONE store score on the page: the computed one
      if (sc && sc.avg) document.querySelectorAll('[data-so-store-rating]').forEach(function (n) { n.textContent = sc.avg; });
    };
    if (storeCache && storeCache.full && Array.isArray(storeCache.reviews)) { storeAll = storeCache.reviews; storeLoaded = true; storeLoading = Promise.resolve(); done(); return storeLoading; }
    var st = 0, paint = function () { if (panelS) panelS.classList.remove('is-loading'); if (st) return; st = setTimeout(function () { st = 0; if (viewS && panelS && !panelS.hidden) viewS.render(); }, 120); };
    storeLoading = shopPage(1).then(function (rs) {
      var got = [rs]; storeAll = rs; paint();
      var pages = Math.min(Math.ceil((shopCount || rs.length) / 25), Math.ceil(CFG.maxStore / 25)), nums = [];
      for (var i = 2; i <= pages; i++) nums.push(i);
      return pool(nums, function (n) { return shopPage(n).then(function (x) { got[n - 1] = x; storeAll = [].concat.apply([], got.filter(Boolean)); paint(); }); });
    }).then(function (failed) { storeLoaded = true; storePartial = !!failed; if (!failed && storeAll.length) cacheSet(SKEY, { count: shopCount, reviews: storeAll, full: true }); },
      function () { storeLoaded = true; storePartial = true; }).then(done);
    return storeLoading;
  }
  function tab(which) {
    $$('[data-so-rvp-tab]', sheet).forEach(function (t) { t.setAttribute('aria-selected', String(t.getAttribute('data-so-rvp-tab') === which)); });
    if (panelP) panelP.hidden = which !== 'p'; if (panelS) panelS.hidden = which !== 's';
    // first visit to the Store tab: a loading state until the first page is in (2026-10-13, Charl: the pop-up went small, then back up)
    if (which === 's') { if (panelS && !storeAll.length && !storeLoaded) panelS.classList.add('is-loading'); if (viewS) viewS.render(); loadStoreAll(); }
    var b = $('.so-dsheet__body', sheet); if (b) b.scrollTop = 0;
  }
  if (sheet) sheet.addEventListener('click', function (e) { var t = e.target.closest('[data-so-rvp-tab]'); if (t) tab(t.getAttribute('data-so-rvp-tab')); });

  function openAll(from, opts) {
    if (!sheet) return;
    opts = opts || {};
    tab(TOTAL > 0 ? 'p' : 's');
    if (viewP) viewP.render();
    open(sheet, from);
    loadAll().then(function () { partial = !!state.partial; if (viewP) viewP.render(); });
  }
  var state = { partial: false };                               // loadAll() flags a failed page here
  document.addEventListener('click', function (e) {
    var ph = e.target && e.target.closest && e.target.closest('[data-so-rv-photo], [data-so-rv-photos]');
    if (ph) { e.preventDefault(); var im = ph.hasAttribute('data-so-rv-photo') ? ph.querySelector('img') : null; pvOpen(ph, im ? (im.currentSrc || im.src) : ''); return; }
    var t = e.target && e.target.closest && e.target.closest('[data-so-rv-all], a[href="#judgeme_product_reviews"], a[href="#so-reviews"]');
    if (!t) return;
    e.preventDefault(); openAll(openEl ? lastFocus : t);
  });
  // Flavour swap (variant-picker's on:variant:change): the row is re-picked for the NEW flavour — its reviews first,
  // then the usual order; a flavour with no reviews simply gets the default order. The row scrolls back to the start.
  document.addEventListener('on:variant:change', function (e) {
    var v = e.detail && e.detail.variant; if (!v) return;
    if (e.target && e.target.closest && e.target.closest('quick-add-drawer')) return;
    var t = String(v.title || '').trim(); if (t === CUR) return;
    CUR = t;
    fillRow();
    if (picks) picks.scrollTo({ left: 0 });
    if (sheet && !sheet.hidden) renderSide();
  });
  window.soReviewsSheet = { open: openAll, close: close };
})();
